import * as React                                     from 'react';
import Button                                         from '@mui/material/Button';
import TextField                                      from '@mui/material/TextField';
import Dialog                                         from '@mui/material/Dialog';
import DialogActions                                  from '@mui/material/DialogActions';
import DialogContent                                  from '@mui/material/DialogContent';
import DialogContentText                              from '@mui/material/DialogContentText';
import DialogTitle                                    from '@mui/material/DialogTitle';
import {CultureForumReplayState, Reply}               from './CultureForumReplay';
import {Box, Stack, Typography}                       from '@mui/material';
import {common}                                       from '../../common/common';
import {useRef}                            from 'react';
import axios                                          from 'axios';
import {constance}                                    from '../../common/constance/constance';
import {RootState}                                    from '../../reducer';
import {useSelector}                                  from 'react-redux';
import DeleteForeverIcon                              from '@mui/icons-material/DeleteForever';
import {styles}                                       from '../../common/style';
import {isMobile} from 'react-device-detect';

type CreateReplyType = {
	user: string,
	post: string,
	content: string,
	id: string,
}

export default function CultureForumReplyDialog(state: CultureForumReplayState, setState: any) {
	console.log('[CultureForumReplyDialog]');
	
	const handleClose = () => {
		setState({
			...state,
			openReply: false,
		});
	};
	
	let inputRef: any = useRef();
	let contentRef: any = useRef();
	const commonData = useSelector((state: RootState) => state.commonData);
	let {id, workplace, no, page} = common.getQuery();

	function handleReplyCreate() {
		let content = inputRef.current.value;
		console.log(content);
		
		let params: CreateReplyType = {
			content: content,
			post: state.selectedForum._id,
			user: commonData.user._id,
			id: id
		};

		axios.post(constance.api.createReply, {
			...params,
		}).then(value => {
			setState({
				...state,
				replyList: value.data.replyList,
			});
			// contentRef.current.style.scroll
		}).catch(reason => {
			console.error(reason);
		}).finally(() => {
			inputRef.current.value = '';
		});
	}
	
	function deleteReply(reply: Reply) {
		axios.post(constance.api.deleteReply, {
			values: {
				reply: reply._id,
			},
		}).then(value => {
			setState({
				...state,
				replyList: value.data.replyList,
			});
		});
	}
	
	return (
			<div>
				<Dialog open={state.openReply} onClose={handleClose} sx={{maxHeight: '100vh'}}>
					<DialogTitle>
						<Box sx={{display: 'flex'}}>
							<Typography variant={'h5'}>
								{`제 ${state.selectedForum.number}회`}
							</Typography>
							<Typography variant={'h5'} sx={{ml: 1}}>
								{state.selectedForum.title}
							</Typography>
						</Box>
					</DialogTitle>
					<DialogContent ref={contentRef}>
						<DialogContentText>
							<Stack sx={{width: {xs: 250, sm: 300, md: 400}}}>
								{
									!common.isEmpty(state.replyList) && state.replyList.map((reply, index) => {
										
										return (
												<Stack key={index}
												       sx={{width: 1, borderRadius: 1, mt: 1, p: 1, background: styles.replyColor}}>
													<Box sx={{display: 'flex', width: 1, position: 'relative'}}>
														<Typography sx={{fontWeight: 700}}>
															{`${reply.user.departmentName} ${reply.user.name}`}
														</Typography>
														
														{
															commonData.user.id == reply.user.id ?
																	<Box sx={{position: 'absolute', right: 0}}>
																		<DeleteForeverIcon onClick={() => deleteReply(reply)}
																		                   sx={{cursor: 'pointer', color: styles.deleteColor}}/>
																	</Box> : ''
														}
													
													</Box>
													<Box sx={{display: 'flex', width: 1}}>
														<Typography sx={{fontWeight: 400}}>
															{`${common.getTimeFormat(reply.createdAt)}`}
														</Typography>
													</Box>
													<Box sx={{display: 'flex', width: 1, p: 1}}>
														<Typography variant={isMobile ? 'caption' : 'subtitle2'}
														            sx={{fontWeight: 400, color: 'text.primary'}}>
															{`${reply.content}`}
														</Typography>
													</Box>
												</Stack>
										);
									})
								}
								
								<Box sx={{mt: 2}}>
									<TextField
											inputRef={inputRef}
											autoFocus
											margin="dense"
											label="내용을 입력해 주세요."
											type="email"
											fullWidth
											variant="standard"
									/>
								</Box>
							</Stack>
						</DialogContentText>
					
					</DialogContent>
					<DialogActions>
						<Button onClick={handleClose}>닫기</Button>
						<Button onClick={handleReplyCreate}>등록</Button>
					</DialogActions>
				</Dialog>
			</div>
	);
}